import { useGetCompanyServicePricesQuery } from '@/store/apiService';
import { CompanyServicePrice } from '@/types/types';

export const useCompanyServicePrices = (
    companyId: string | undefined,
    enabled: boolean
): CompanyServicePrice[] => {
    const result = useGetCompanyServicePricesQuery(
        { CompanyId: companyId!, Active: true },
        { skip: !companyId || !enabled }
    );
    return result.data?.Results ?? [];
};
